
const bootRollbar = user => {
    const payload = {
     // environment: currentEnvironment(),
      javascript: {
        guess_uncaught_frames: true,
      },
    }

    if (user) {
      const { id, email } = user
      payload.person = {
        id,
        email,
        username: email,
      }
    }
    window.Rollbar.configure({payload})
  }
  
  export default bootRollbar
  